"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var ShareAction_1 = require("@/pages/common/actions/ShareAction");
var mapDispatchToProp = function (dispatch) { return ({
    setShareActive: function (state) { return dispatch(ShareAction_1.default.setShareActive(state)); },
    onCopyClicked: function () { return dispatch(ShareAction_1.default.onCopyClicked()); },
}); };
var mapStateToProps = function (state) { return (__assign({}, state.share)); };
var share = function (props) {
    var onBgClick = function (event) {
        if (event.currentTarget !== event.target)
            return;
        props.setShareActive(false);
    };
    var onCopyClicked = function (event) {
        event.preventDefault();
        props.onCopyClicked();
    };
    var onInputClicked = function (event) {
        props.onCopyClicked();
    };
    var onCloseClick = function () { return props.setShareActive(false); };
    return props.isActive ? (React.createElement("div", { onClick: onBgClick, className: "l-share" },
        React.createElement("div", { className: "l-share__body" },
            React.createElement("div", { className: "l-share__title" }, props.title),
            React.createElement("div", { className: "l-share__url" },
                React.createElement("input", { onClick: onInputClicked, className: "c-share__input", type: "text", value: props.url, readOnly: true }),
                React.createElement("a", { href: "#", title: props.nameCopy, onClick: onCopyClicked, className: "c-share__copy" },
                    React.createElement("span", { className: "fal fa-copy" }))),
            React.createElement("div", { className: "l-share__buttons" },
                React.createElement("a", { target: "_blank", href: "http://www.facebook.com/sharer.php?u=" + props.url, className: "c-share c-share--facebook" }),
                React.createElement("a", { target: "_blank", href: "http://twitter.com/share?url=" + props.url, className: "c-share c-share--twitter" }),
                React.createElement("a", { target: "_blank", href: "https://api.whatsapp.com/send?text=" + props.url, className: "c-share c-share--whatsapp" })),
            React.createElement("div", { onClick: onCloseClick, className: "l-share__close" },
                React.createElement("span", { className: "fas fa-times" }))))) : null;
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProp)(share);
